
export const CLOUD_STORAGE_URL = "gs://stampdemo-528a3.appspot.com";
export const CLOUD_FUNCTION_URL = 'https://us-central1-pointant-admin.cloudfunctions.net';
export const DATE_FORMAT = 'DD/MM/YYYY'
export const UUID_NAMESPACE = 'https://www.pointant-app.com'
export const REST_API_URL = 'https://pointant-app.com/api'
